import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IZBFortyAGM = ({question,answer}) => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowLeft}
      className={className}
      style={{
        ...style,
        display: "block",
        width: "50px",
        height: "50px",
        left: "-58px",
        zIndex:"99"
      }}
      onClick={onClick}
    />
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowRight}
      className={className}
 
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}; 
  
  return (
    <>
      <Breadcrumb2
        Heading="Latest News"
        img={BackgroundBrundcrumb}
        show={true}
      
      />

        <section>
            <div className="container pt-5">
              <h1 className="pb-5 text-left">IZB 40th Annual General Meeting</h1>
    
              <p className="pb-3">Last Friday, the bank held its 40th Annual General Meeting, followed by a press briefing where our Board Chairman, Dr. Michael Gondwe, shared highlights of the Bank’s 2024 financial performance.</p>

              <p className="pb-3">"The Bank's total revenue grew by 18.5%, from K1.69 billion in 2023 to K2.00 billion in 2024. In terms of profitability, the Bank saw an increase in Net Profit after tax from K604 million in 2023 to K724 million in 2024. The Bank’s total business grew by 21.58%, rising from K18.64 billion in 2023 to K22.65 billion in 2024. This position was strengthened by an increase in total deposits which grew to K16.12 billion. Additionally, loans and advances to customers increased from K5.87 billion in 2023 to K6.543 billion in 2024, demonstrating significant growth in the loan portfolio.” – Dr. Michael Gondwe, Board Chairman.</p>

              <p className="pb-3">During the same briefing, the Bank proudly announced a dividend payout of K150 million, with K60 million presented to the Industrial Development Corporation (IDC). The cheque was received by IDC Acting CEO, Mrs. Leya Mtonga Ngoma, who commended the Bank’s resilience:</p>

              <p className="pb-3">"We are happy to learn that despite the turbulences encountered at national level in 2024, Indo Zambia Bank’s balance sheet indicates that total assets grew by 22.97%, increasing to K20.85 billion as of 31 December 2024." – Mrs. Leya Mtonga Ngoma, Acting Chief Exextuvie Officer - Industrial Development Corporation.</p>

              <p className="pb-3">Our Managing Director Mr. Brajesh Kumar Singh said “The banks primary focus in 2024 was on consolidating its market share with the goal of expanding market presence in different geographic regions nationwide”</p>

              <p className="pb-3">As we commemorate this remarkable milestone and outstanding financial performance, we reaffirm our mission to act as the catalyst for economic development of Zambia.</p>

              <h2 className="pt-4 pb-4">Gallery</h2>
            
              <div className="test news-slider-list-slider row align-items-center">
                <Slider {...settings}>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-40th-annual-general-meeting-1.png" alt="IZB 40th Annual General Meeting Banner" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-40th-annual-general-meeting-2.png" alt="IZB 40th Annual General Meeting Banner" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-40th-annual-general-meeting-3.png" alt="IZB 40th Annual General Meeting Banner" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-40th-annual-general-meeting-4.png" alt="IZB 40th Annual General Meeting Banner" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-40th-annual-general-meeting-5.png" alt="IZB 40th Annual General Meeting Banner" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-40th-annual-general-meeting-6.png" alt="IZB 40th Annual General Meeting Banner" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-40th-annual-general-meeting-7.png" alt="IZB 40th Annual General Meeting Banner" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-40th-annual-general-meeting-8.png" alt="IZB 40th Annual General Meeting Banner" />
                  </div>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-40th-annual-general-meeting-9.png" alt="IZB 40th Annual General Meeting Banner" />
                  </div>
                </Slider>
              </div>
            </div>

            

        </section>

      <CustomerCare />
      <OurStores />

    </>
  );
};

export default IZBFortyAGM;